export default "__VITE_ASSET__DQs7oOlt__"